"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DualBaseLayerWithResolutionSwitch = void 0;
var Map_1 = require("ol/Map");
var DualBaseLayerWithResolutionSwitch = /** @class */ (function () {
    /***
    * @_minZoomOrResolutionForPrimaryLayer the zoom level (as int) or the resolution (as decimal) where the secondary layer is shown
    */
    function DualBaseLayerWithResolutionSwitch(_ref, _displayName, _primaryLayer, _secondaryLayer, _minZoomOrResolutionForPrimaryLayer) {
        var _this = this;
        this._ref = _ref;
        this._displayName = _displayName;
        this._primaryLayer = _primaryLayer;
        this._secondaryLayer = _secondaryLayer;
        this._minZoomOrResolutionForPrimaryLayer = _minZoomOrResolutionForPrimaryLayer;
        this._lastZoomLevel = 0;
        this._lastResolution = 0;
        this._visible = false;
        this.addOnMapResolutionChangedHandler = function (map) {
            var self = _this;
            var addZoomHandler = function () {
                map.getView().on("change:resolution", function (e) {
                    console.log("zoom=" + e.target.getZoom());
                    console.log("resolution=" + e.target.getResolution());
                    self._lastZoomLevel = e.target.getZoom();
                    self._lastResolution = e.target.getResolution();
                    //this event seems to be firing multiple times until an integer zoomlevel is reached
                    //we therefore need to test for when zoom is a whole int before we do anything
                    if (e.target.getZoom() % 1 === 0) {
                        self.setLayerVisibility();
                    }
                });
            };
            //handle view change too
            //if the view is changed we lose the handler            
            map.on("change:view", function (e) {
                setTimeout(function () {
                    addZoomHandler();
                }, 100);
            });
            addZoomHandler();
        };
        this.setLayerVisibility = function () {
            var self = _this;
            //only do this if the dual base layer is visible as a whole
            if (self._visible === true) {
                if (self._lastZoomLevel === 0) {
                    self.showPrimaryLayer();
                    return;
                }
                if (self._minZoomOrResolutionForPrimaryLayer % 1 === 0) {
                    //if _minZoomOrResolutionForBottomlayer is a whole number then treat it as a zoom level           
                    self.setPrimaryLayerVisibility(self._lastZoomLevel > self._minZoomOrResolutionForPrimaryLayer);
                }
                else {
                    //otherwise it's a resolution            
                    self.setPrimaryLayerVisibility(self._lastResolution <= self._minZoomOrResolutionForPrimaryLayer);
                }
            }
        };
        this.setPrimaryLayerVisibility = function (showPrimaryLayer) {
            if (showPrimaryLayer && !_this._primaryLayer.getVisible()) {
                //show primary layer
                _this.showPrimaryLayer();
            }
            else if (!showPrimaryLayer && !_this._secondaryLayer.getVisible()) {
                //show secondary layer
                _this.showSecondaryLayer();
            }
        };
        this.showPrimaryLayer = function () {
            _this._secondaryLayer.setVisible(false);
            _this._primaryLayer.setVisible(true);
        };
        this.showSecondaryLayer = function () {
            _this._secondaryLayer.setVisible(true);
            _this._primaryLayer.setVisible(false);
        };
    }
    Object.defineProperty(DualBaseLayerWithResolutionSwitch.prototype, "ref", {
        get: function () {
            return this._ref;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualBaseLayerWithResolutionSwitch.prototype, "displayName", {
        get: function () {
            return this._displayName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualBaseLayerWithResolutionSwitch.prototype, "olLayer", {
        get: function () {
            return this._primaryLayer;
        },
        enumerable: false,
        configurable: true
    });
    DualBaseLayerWithResolutionSwitch.prototype.setVisible = function (visible) {
        this._visible = visible;
        //if false turn both layers off, otherwise let it proceed
        if (!this._visible) {
            this._secondaryLayer.setVisible(false);
            this._primaryLayer.setVisible(false);
        }
        else {
            this.setLayerVisibility();
        }
    };
    DualBaseLayerWithResolutionSwitch.prototype.getVisible = function () {
        return this._visible;
        //return this._primaryLayer.getVisible() || this._secondaryLayer.getVisible();
    };
    DualBaseLayerWithResolutionSwitch.prototype.setOpacity = function (opacity) {
        this._primaryLayer.setOpacity(opacity);
        this._secondaryLayer.setOpacity(opacity);
    };
    DualBaseLayerWithResolutionSwitch.prototype.addLayerToMap = function (map, visibility) {
        if (map instanceof Map_1.default) {
            this._lastZoomLevel = map.getView().getZoom();
            this._lastResolution = map.getView().getResolution();
            this.setVisible(visibility);
            map.addLayer(this._primaryLayer);
            map.addLayer(this._secondaryLayer);
            this.addOnMapResolutionChangedHandler(map);
        }
        else {
            this._lastZoomLevel = map.olMap.getView().getZoom();
            this._lastResolution = map.olMap.getView().getResolution();
            this.setVisible(visibility);
            map.olMap.addLayer(this._primaryLayer);
            map.olMap.addLayer(this._secondaryLayer);
            this.addOnMapResolutionChangedHandler(map.olMap);
        }
    };
    return DualBaseLayerWithResolutionSwitch;
}());
exports.DualBaseLayerWithResolutionSwitch = DualBaseLayerWithResolutionSwitch;
//# sourceMappingURL=DualBaseLayerWithResolutionSwitch.js.map